import {data} from "autoprefixer";

const deviceBase = `        
    <div class="device" data-type="#:Type#" data-device-id="#:Id#">
        <img src="/public/images/devices/#:ImageName#" alt="#:Name#" />
        <h3>Unknown Device</h3>
    </div>
`;

const computerTemplate = kendo.template(`
    #if(Visible){#
        <div class="device" data-type="#:Type#" data-device-id="#:Id#">
            <img src="/public/images/devices/#:ImageName#" alt="#:Name#" />
            <h3>#:MachineName#</h3>
            <h3>#:Manufacturer#</h3>
            <h3>#:Model#</h3>
        </div>
    #}#
`);

const mobileTemplate = kendo.template(`
    #if(Visible){#
        <div class="device" data-type="#:Type#" data-device-id="#:Id#">
          <img src="/public/images/devices/#:ImageName#" alt="#:Name#" />
          <h3>#:Model#</h3>
          <h3>#:Type#</h3>
        </div>
    #}#
`);

export const getTemplate = function (dataItem) {
    dataItem.Visible = dataItem.Visible === undefined ? true : dataItem.Visible;
    switch (dataItem.Type) {
        case 'Computer':
            return computerTemplate(dataItem);
        case 'Tablet':
        case 'Phone':
            return mobileTemplate(dataItem);
    }
    return kendo.template(deviceBase);
};

const rowTemplate = kendo.template(`
    #if(Visible){#
        <tr class="k-master-row"  data-uid="#:uid #" role="row" data-type="#:Type#" data-device-id="#:Id#">
            <td class="" role="gridcell">#:Type#</td>
            <td class="" role="gridcell">#:Name#</td>
            <td class="" role="gridcell">#:Status#</td>
        </tr>
    #}#
`);

const altRowTemplate = kendo.template(`
    #if(Visible){#
        <tr class="k-alt k-master-row"  data-uid="#:uid#" role="row" data-type="#:Type#" data-device-id="#:Id#">
            <td class="" role="gridcell">#:Type#</td>
            <td class="" role="gridcell">#:Name#</td>
            <td class="" role="gridcell">#:Status#</td>
        </tr>
    #}#
`);

export const getRowTemplate = function (dataItem) {
    dataItem.Visible = dataItem.Visible === undefined ? true : dataItem.Visible;
    return rowTemplate(dataItem);
};

export const getAltRowTemplate = function (dataItem) {
    dataItem.Visible = dataItem.Visible === undefined ? true : dataItem.Visible;
    return altRowTemplate(dataItem);
};